import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ConfigService} from "../config/config.service";
import {Contrato} from "../types/Contrato.type";
import {Parcela} from "../types/Parcela.type";
import {ContratoTMA} from "../types/ContratoTMA.type";

@Injectable({
  providedIn: 'root'
})
export class ContratoService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  getContratos(page: number, size: number, sortField: string, sortDirection: string, instancias: string, filtro: string, status: string){

    return this.httpClient.get<Contrato[]>(`${this.configService.getApiUrlRoot()}/contratos/basico?instancias=${instancias}&filtro=${filtro}&status=${status}`)

  }

  getParcelasPagamento(instancias: string, dataInicio: string, dataFim: string, status: string){

    return this.httpClient.get<Parcela[]>(`${this.configService.getApiUrlRoot()}/contratos/pagamento?instancias=${instancias}&dataInicio=${dataInicio}&dataFim=${dataFim}&status=${status}`)

  }

  getContrato(instancia: string, contrato: number){

    return this.httpClient.get<Contrato>(`${this.configService.getApiUrlRoot()}/contratos/busca?instancia=${instancia}&contrato=${contrato}`)

  }

  getBuscaPagamentos(instancias: string, dataInicio: string, dataFim: string, contrato: string = ""){

    return this.httpClient.get(`${this.configService.getApiUrlRoot()}/contratos/pagamento/buscar-pagamentos?instancias=${instancias}&dataInicio=${dataInicio}&dataFim=${dataFim}&contrato=${contrato}`)

  }

  postEnviarPagamentos(corpo: any){
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/contratos/pagamento/enviar-erp`, corpo);
  }

  buscaContratos(usuario: string | null){
    return this.httpClient.get(`${this.configService.getApiUrlRoot()}/contratos/integracao/busca-contratos?usuario=${usuario}`)
  }


  postEnviarContratos(corpo: any){
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/contratos/integracao/enviar-erp`, corpo);
  }

  exportarContratosParcelas(corpo: any){
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/contratos/relatorios/exportar/parcelas`, corpo, { responseType: 'blob'});
  }

  exportarContratos(corpo: any){
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/contratos/relatorios/exportar`, corpo, { responseType: 'blob'});
  }

  getTmas(){
    return this.httpClient.get<ContratoTMA[]>(`${this.configService.getApiUrlRoot()}/contratos/tma`);
  }

  getTma(id: string){
    return this.httpClient.get<ContratoTMA>(`${this.configService.getApiUrlRoot()}/contratos/tma/id?id=${id}`);
  }

  postTma(contratoTma: ContratoTMA){
    return this.httpClient.post<ContratoTMA>(`${this.configService.getApiUrlRoot()}/contratos/tma`, contratoTma);
  }

  putTma(contratoTma: ContratoTMA){
    return this.httpClient.put<ContratoTMA>(`${this.configService.getApiUrlRoot()}/contratos/tma`, contratoTma);
  }

  deleteTma(id: string){
    return this.httpClient.delete(`${this.configService.getApiUrlRoot()}/contratos/tma/${id}`);
  }

  exportarParametros(corpo: any){
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/contratos/relatorios/exportar/parametros`, corpo, { responseType: 'blob'});
  }

  cancelar(corpo: any, dataBaixa?: string){
    const query = dataBaixa ? `?dataBaixa=${dataBaixa}` : '';
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/contratos/integracao/cancelar-erp${query}`, corpo);
  }
}
